import { gql } from '@apollo/client';

export const ADD_UPDATE_PARTNER_TYPES = gql`
  mutation savePartnerTypes($input: [PartnerTypeInput]!) {
    savePartnerTypes(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_PARTNER_TYPE = gql`
  mutation deletePartnerType($partnerTypeId: Int!) {
    deletePartnerType(partnerTypeId: $partnerTypeId) {
      commandId
      correlationId
    }
  }
`;
